import { render } from "./DocumentoUtilizador.vue?vue&type=template&id=3beab03a&scoped=true"
import script from "./DocumentoUtilizador.vue?vue&type=script&lang=js"
export * from "./DocumentoUtilizador.vue?vue&type=script&lang=js"

import "./DocumentoUtilizador.vue?vue&type=style&index=0&id=3beab03a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3beab03a"]])

export default __exports__